import { render } from "./Manpower.vue?vue&type=template&id=7062c65e&scoped=true"
import script from "./Manpower.vue?vue&type=script&lang=js"
export * from "./Manpower.vue?vue&type=script&lang=js"

import "./Manpower.vue?vue&type=style&index=0&id=7062c65e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7062c65e"]])

export default __exports__